export const classNames = (...values: Array<string | undefined | false | null>) =>
  values.filter(Boolean).join(' ');
